import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  UpdateHomeScreenBanner,
  UpdateHomeScreenBannerVariables
} from './__generated__/UpdateHomeScreenBanner'

const MUTATION = gql`
  mutation UpdateHomeScreenBanner($input: UpdateHomeScreenBannerInputV2!) {
    updateHomeScreenBanner: updateHomeScreenBannerV2(input: $input) {
      ... on HomeScreenBannerV2 {
        id
        title
        description
        backgroundColor
        positionInFeed
        buttons {
          title
          deepLinkUrl
        }
      }
      ... on HomeScreenBannerErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateHomeScreenBanner = () =>
  useMutation<UpdateHomeScreenBanner, UpdateHomeScreenBannerVariables>(MUTATION)
